module.exports = __webpack_public_path__ + "img/FEMP_65h.36bbae4f.png";